export const data = [
  {
    id: 1,
    title: 'Onedio Analytics Verileri',
    titleEN: 'Onedio Analytics Data',
    image: 'https://srv-cdn.onedio.com/store/6596b5ce9d9308550bc731f550e221c27493c3661788442d9be12348a1ff7add.png',
    imageEN: 'https://srv-cdn.onedio.com/store/4ec91d3747e304a53282f86ff67738d236e9d3599c02f1a52d82f6063fe51dfd.png',
    active: true
  },
  {
    id: 2,
    title: 'Cinsiyet',
    titleEN: 'Gender',
    image: 'https://srv-cdn.onedio.com/store/f9713648d88198c089f03d3cd5bdeba125fc297d6a7802b325eea8ab05dc0257.png',
    imageEN: 'https://srv-cdn.onedio.com/store/f9713648d88198c089f03d3cd5bdeba125fc297d6a7802b325eea8ab05dc0257.png',
    active: false
  },
  {
    id: 3,
    title: 'Yaş Kırılımı',
    titleEN: 'Age Distribution',
    image: 'https://srv-cdn.onedio.com/store/b55bf5bdac52b336d1164008a122938a06ffc6a058a0fe1d3cba45108fd75af5.png',
    imageEN: 'https://srv-cdn.onedio.com/store/b55bf5bdac52b336d1164008a122938a06ffc6a058a0fe1d3cba45108fd75af5.png',
    active: false
  },
  {
    id: 4,
    title: 'Sosyal Medya',
    titleEN: 'Social Media',
    socialSlides: true,
    active: false
  }
]
